var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dc-post-grid-pagination-wrapper"},[_c('p',[_vm._v(_vm._s(this.dctxt('showing'))+" "+_vm._s(_vm.$parent.results.length)+" "+_vm._s(this.dctxt('of'))+" "+_vm._s(_vm.totalPosts))]),_vm._v(" "),_c('button',{class:[
			'dc-post-grid-load-more',
			'dc-button',
			'dc-button--has-title',
			'dc-button--has-icon',
			'dc-button--color-grey',
			{ 'dc-button--is-loading': _vm.loading } ],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.loadMore(_vm.currentPaged)}}},[_vm._v(_vm._s(_vm.label)),_c('span',{staticClass:"icon icon-plus"})])])}
var staticRenderFns = []

export { render, staticRenderFns }